import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import * as dateutil from "@appbase/util/date-helper";

import { FullMasterTemplate } from '@/modules/@appbase/templates'
import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue'
import AttendanceManageFilter from '@home/components/KyoboBook/AttendanceManage/AttendanceManageFilter.vue'
import AttendanceManage from '@home/components/KyoboBook/AttendanceManage/AttendanceManage.vue'
import { AttendanceManageFilterModel } from '@home/components/KyoboBook/AttendanceManage/AttendanceManageFilter'

@Component({
    components: {
        FullMasterTemplate,
        GnbLeftView,
        AttendanceManageFilter,
        AttendanceManage
    }
})
export default class AttendanceManageView extends Vue {
    weekList: Date[] = [];
    selectedWorkPart: string = '';
    selectedTask: string = '';

    attendanceDataList: any[] = [];
    storeType: number = 1; // 1: 소형, 2,3: 대형
    
    setFilter(filterData: AttendanceManageFilterModel) {
        this.selectedWorkPart = filterData.selectedWorkPart;
        this.selectedTask = filterData.selectedTask;

        this.setWeekList(filterData.targetDate);
        this.loadData();
    }

    setWeekList(date: Date) {
        let startDate = dateutil.uGetWeekStartDate(date, 1);
        let daysList = dateutil.uGetDaysInWeek(startDate, 1);

        this.weekList = daysList;
    }

    loadData() {
        
    }
}